import React from "react";
import { createPortal } from "react-dom";

const TelemedicineInfoPopup = ({ show, onClose, title, content }) => {
  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center z-[9999]">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      ></div>

      {/* Popup */}
      <div className="bg-white dark:bg-gray-800 rounded-lg max-w-md mx-4 my-8 z-[10000] shadow-lg max-h-[90vh] w-full flex flex-col">

        {/* Header (sticky) */}
        <div className="sticky top-0 bg-white dark:bg-gray-800 z-10 px-5 py-4 border-b border-gray-200 dark:border-gray-700 flex items-start justify-between">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            {title}
          </h3>

          <button
            className="ml-3 px-3 py-1 bg-purple-600 text-white rounded hover:bg-purple-700 dark:bg-purple-500 dark:hover:bg-purple-600 text-sm font-medium"
            onClick={onClose}
            aria-label="Close popup"
          >
            Close
          </button>
        </div>

        {/* Scrollable content */}
        <div className="px-5 py-4 overflow-y-auto">
          <p className="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-line">
            {content}
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TelemedicineInfoPopup;
